import React from "react";
import SimpleCharts from "./BarChart";
import GaugeValueRangeNoSnap from "./PieChart";

const DashboardProgress = () => {
  return (
    <div className="dashboard-content">
      <div className="home-heading-container">
        <h1 className="heading-text-h1">Performance</h1>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="video-cards-container">
        <div className="Graph-container">
          <p>Weekly Attendance </p>
          <SimpleCharts className="chart" />
        </div>
        <div className="Graph-container-2">
          <p>Course </p>
          <GaugeValueRangeNoSnap className="pie-chart" />
        </div>
      </div>
    </div>
  );
};

export default DashboardProgress;
